module.exports = __webpack_public_path__ + "img/service-09.e400736c.svg";